import React from 'react'

import { connect } from "react-redux"

import { Form } from 'react-form'

import { Message } from 'primereact/message'

import LobbyistDetails from '../components/lobbyist/lobbyist-details'
import Employee from './Employee'
import Client from './Client'
import LobbyistActions from './LobbyistActions'
import AnnualReturnTable from './AnnualReturnTable'
import ChangePassword from '../components/common/ChangePasswordSection'

import { STATUS_AWAITING_APPROVAL, ROLE_ADMIN, STATUS_AWAITING_SUBMIT } from '../js/const'

import * as employeeActionCreators from "../actionCreators/employee"
import * as clientActionCreators from "../actionCreators/client"
import * as lobbyistActionCreators from "../actionCreators/lobbyist"
import * as appActionCreators from "../actionCreators/app"
import * as authActionCreators from "../actionCreators/auth"
import * as annualReturnActionCreators from "../actionCreators/annualReturn"
import * as lookupCodeActionCreators from "../actionCreators/lookupCode"
import * as systemParameterActionCreators from "../actionCreators/systemParameter"

import { withRouter } from 'react-router' // need to use withRouter higher order component to access the routing history since the menu isn't a component contained in the current route

class Lobbyist extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // flag stored at container level because we want to know when the container itself has loaded so we can hide/show based on that
      // this way any loading done by child components doesn't cause the container to be hidden
      hasLoaded: false,
      // you flag to determine if lobbyist is being submitted as the save and submit uses the same form but does different things
      isSubmitting: false
    }
  }

  componentDidMount() {
    //is invoked immediately after a component is mounted. 
    //Initialization that requires DOM nodes should go here. If you need to load data from a remote endpoint, this is a good place to instantiate the network request.  
    this.loadLobbyist(this.props.match.params.lobbyistId)
  }

  // check if component is required to be updated if parameter has changed because going from one lobbyist to another doesn't make the component re mount
  componentDidUpdate(prevProps) {
    let previousLobbyistId = prevProps.match.params.lobbyistId
    let lobbyistId = this.props.match.params.lobbyistId

    // reload lobbyist if parameter has changed
    if (previousLobbyistId !== lobbyistId) {
      this.loadLobbyist(lobbyistId)
    }
  }

  loadLobbyist = lobbyistId => {
    //is invoked immediately after a component is mounted. 
    //Initialization that requires DOM nodes should go here. If you need to load data from a remote endpoint, this is a good place to instantiate the network request.   
    this.props.setLoading(true)
      .then(() => {
        // store the promises in an array so we can kick off loading at the same time but it won't continue until all the loading has finished
        let dataloadPromises = []
        dataloadPromises.push(this.props.getRegistrationText())
        dataloadPromises.push(this.props.getDPCNotificationEmail())
        if (lobbyistId) {
          dataloadPromises.push(this.props.getLobbyist(lobbyistId))
          // TODO move outside of Lobbyist container to their own containers
          dataloadPromises.push(this.props.getClientsForLobbyists(lobbyistId))
          dataloadPromises.push(this.props.getEmployeesForLobbyist(lobbyistId))
          dataloadPromises.push(this.props.getAnnualReturnsForLobbyist(lobbyistId))
          return Promise.all(dataloadPromises)
        } else {
          // still call action to load data so we can load the validation rules required
          dataloadPromises.push(this.props.getLobbyist(null))
          // TODO move outside of Lobbyist container to their own containers
          dataloadPromises.push(this.props.clearClientsFromLobbyist())
          dataloadPromises.push(this.props.clearEmployeesFromLobbyist())
          dataloadPromises.push(this.props.clearAnnualReturnsFromLobbyist())
          return Promise.all(dataloadPromises)
        }
      })
      .then(() => this.props.getAnnualReturnTypes())
      .then(() => this.props.setLoading(false))
      .then(() => this.setState({ hasLoaded: true }))
      .catch(error => {
        if (error.response && error.response.status === 401) {
          this.props.history.push('/error/401')
          this.props.setLoading(false)
        } else {
          this.props.handleError(error)
            .then(() => this.props.setLoading(false))
            .then(() => this.setState({ hasLoaded: true }))
        }
      })
  }

  // this function will be called when the form is submitted successfully
  // the lobbyist object passed is in the same structure as the object bound to <Form> values property
  // the object will have been updated based on user input
  formSubmittedSuccessfully = lobbyist => {
    // check what action is being performed since validation has passed
    if (this.state.isSubmitting) {
      this.submitLobbyist(lobbyist)
    } else {
      this.saveLobbyist(lobbyist)
    }
  }

  saveLobbyist = lobbyist => {
    this.props.setLoading(true)
      .then(() => {
        if (lobbyist.LobbyistId) {
          // second step is lobbyist being updated
          this.props.updateLobbyist(lobbyist)
            .then(response => {
              // set response in store so global response component can handle response
              this.props.setAjaxResponse(response)
              this.props.setLoading(false)
            })
            .catch((error) => this.props.handleError(error)
              .then(() => this.props.setLoading(false)))
        } else {
          // get username and password so we can create an account and login when successfully registered
          let accountDetails = { Username: lobbyist.ResponsibleOfficerEmail, Password: lobbyist.NewPassword }
          // first step is lobbyist being registered
          this.props.addLobbyist(lobbyist)
            .then(response => {
              // set response in store so global response component can handle response
              /*
                  response json structure is:
                  {
                      "$id":"1",
                      "SuccessOutput":null,
                      "Success":false,
                      "ErrorMessages":{
                          "$id":"2",
                          "$values":[
                              "Name is required"
                          ]
                      },
                      "WarningMessages":{
                          "$id":"3",
                          "$values":[

                          ]
                      }
                  }
              */
              this.props.setAjaxResponse(response)
              if (response.data.Success) {
                let addResponse = response
                // lobbyist has successfully registered so login and take them to their page
                this.props.performLogin(accountDetails)
                  .then(response => {
                    if (response.data.access_token) {
                      this.props.history.push('/lobbyist/' + addResponse.data.SuccessOutput.LobbyistId)
                      window.scrollTo(0, 0)
                    }
                    this.props.setLoading(false)
                  })
                  .catch((error) => this.props.handleError(error)
                    .then(() => this.props.setLoading(false)))
              }
              this.props.setLoading(false)
            })
            .catch((error) => this.props.handleError(error)
              .then(() => this.props.setLoading(false)))
        }
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  // third step is lobbyist submitting for approval
  submitLobbyist = lobbyist => {
    this.props.setLoading(true)
      .then(() => {
        this.props.submitLobbyist(lobbyist)
          .then(response => {
            this.props.setAjaxResponse(response)
            this.props.setLoading(false)
          })
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  setIsSubmitting = isSubmitting => this.setState({ isSubmitting: isSubmitting })

  render() {
    // check if current lobbyist that is being looked at exists. If not create an empty object to deal with issues that could be caused by lobbyist being undefined
    let currentLobbyist = this.props.lobbyist.currentLobbyist ? this.props.lobbyist.currentLobbyist : {}
    let validationRules = currentLobbyist.ValidationRules ? currentLobbyist.ValidationRules.$values : []

    let isAuthenticated = this.props.auth.isAuthenticated
    let isAdd = !currentLobbyist.LobbyistId
    let isAdmin = this.props.auth.roles && this.props.auth.roles.some(role => role === ROLE_ADMIN)

    let isAwaitingSubmission = currentLobbyist.StatusCode === STATUS_AWAITING_SUBMIT
    let isAwaitingApproval = currentLobbyist.StatusCode === STATUS_AWAITING_APPROVAL

    let isCorrectLobbyist = currentLobbyist.LobbyistId === this.props.auth.lobbyistId

    let canSave = (isAdd === false && isAuthenticated === true && (isAdmin === true || (isCorrectLobbyist && isAwaitingApproval === false))) || isAdd
    let canSeePrivateData = (isAdd === false && isAuthenticated === true && (isAdmin === true || isCorrectLobbyist)) || isAdd
    let dpcEmail = this.props.systemParameter.dpcNotificationEmail
    let redactionMessage = <span>
      <a href={`mailto:${dpcEmail}?subject=Re:%20SA%20Lobbyist%20Register`}>Contact the SA Lobbyist Register team</a> if you wish any of your information (e.g. personal address) to remain private.
    </span>
    return (
      <React.Fragment>
        {isAdd === true && this.state.hasLoaded && <div className={"registration-text"} dangerouslySetInnerHTML={{ __html: this.props.systemParameter.registrationText }} />}
        {/* values sets the form state. I'm binding to the props which is linked redux so we can update the store and the form will be reflected
                   this is useful when needed to clear the form or populating the form from another component
                   onSubmit is called when the form has been submitted and has passed validation
                   formApi properties can be found at https://react-form.js.org/#/*/}
        <Form values={currentLobbyist} onSubmit={this.formSubmittedSuccessfully}>
          {formApi => {
            return (
              <div className="lobbyist-details">
                {this.state.hasLoaded && isAdd === false && isAwaitingSubmission === true && <div className="p-col-12 p-md-12 p-lg-12">
                        <Message style={{ width: '100%' }} severity="info" text="Fill in employee and client details (if any) and click register. Registration will not be accepted until at least one lobbyist is listed in the �People Undertaking Lobbyist Activities� table."></Message>
                </div>}
                {this.state.hasLoaded && <LobbyistDetails currentLobbyist={currentLobbyist} canSave={canSave} canSeePrivateData={canSeePrivateData} isAdmin={isAdmin} isAuthenticated={isAuthenticated} />}
                {this.state.hasLoaded && isAdd === false && <Employee canSave={canSave} canSeePrivateData={canSeePrivateData} lobbyistId={currentLobbyist.LobbyistId} />}
                {this.state.hasLoaded && isAdd === false && <Client canSave={canSave} lobbyistId={currentLobbyist.LobbyistId} />}
                {this.state.hasLoaded && isAdd === false && (isAwaitingSubmission === false && isAwaitingApproval === false) && <AnnualReturnTable canSave={canSave} lobbyistId={currentLobbyist.LobbyistId} />}
                {this.state.hasLoaded && isAdd === false && isAdmin === true && canSeePrivateData && <ChangePassword validationRules={validationRules} isAdmin={isAdmin} />}
                {this.state.hasLoaded && isAdd === false && isAwaitingSubmission === true && redactionMessage && <div className="p-col-12 p-md-12 p-lg-12">
                  <Message style={{ width: '100%' }} severity="info" text={redactionMessage}></Message>
                </div>}
                {this.state.hasLoaded && <LobbyistActions formApi={formApi} setIsSubmitting={this.setIsSubmitting} />}
              </div>
            )
          }
          }
        </Form>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

// this is how to combine actions available
const actionCreators = {
  ...employeeActionCreators,
  ...lobbyistActionCreators,
  ...appActionCreators,
  ...clientActionCreators,
  ...authActionCreators,
  ...annualReturnActionCreators,
  ...lookupCodeActionCreators,
  ...systemParameterActionCreators
}

export default withRouter(connect(mapStateToProps, actionCreators)(Lobbyist))


// WEBPACK FOOTER //
// ./src/container/Lobbyist.js